import { render, staticRenderFns } from "./EditFormRule.vue?vue&type=template&id=095705aa"
import script from "./EditFormRule.vue?vue&type=script&lang=js"
export * from "./EditFormRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports